var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpeakers = function SvgSpeakers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.9 19.4",
    style: {
      enableBackground: "new 0 0 18.9 19.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M16.6,5.1h-0.9C15.4,2.2,13,0,10.1,0H8.8C5.9,0,3.5,2.2,3.2,5.1H2.2C1,5.1,0,6.1,0,7.3v3.6c0,1.2,1,2.2,2.2,2.2 h1.5c0.3,0,0.6-0.3,0.6-0.6V5.7c0-2.4,2-4.4,4.4-4.4h1.3c2.4,0,4.4,2,4.4,4.4v6.8c0,1.8-1.1,3.5-2.8,4.1c-0.3-0.6-1-1-1.7-1 c-1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9c0.9,0,1.7-0.7,1.9-1.6c2.1-0.7,3.5-2.5,3.8-4.7h0.9c1.2,0,2.2-1,2.2-2.2V7.3 C18.9,6.1,17.9,5.1,16.6,5.1z M17.6,7.3v3.6c0,0.5-0.4,1-1,1h-0.9V6.3h0.9C17.2,6.3,17.6,6.7,17.6,7.3z M3.1,6.3v5.5H2.2 c-0.5,0-1-0.4-1-1V7.3c0-0.5,0.4-1,1-1H3.1z M10.7,17.5c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7 S10.7,17.1,10.7,17.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeakers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speakers.469da5c1.svg";
export { ForwardRef as ReactComponent };